import React, { useEffect, useState, useRef } from 'react'
import './Layout.scss'
import { getCurrentConfig } from '../../api/commonApi'
import { setRateCnyToVnd } from '../../redux/ducks/commonDucks'
import { AppDispatch, RootState } from '../../redux/store'
import { useDispatch, useSelector } from 'react-redux'
import { Menu, Dropdown, Button, Row } from 'antd';
import { Link, useLocation } from 'react-router-dom'
import routerConstants from '../../constants/routerConstants'
import { useUserMenu } from '../../constants/menuConstants'
import { getUserInfo, logOut, getProjectInfo, getBranchInfo } from '../../utils/userUtils'
import * as queryString from 'query-string'
import { getListAllNotification } from '../../redux/ducks/notificationDucks'
import * as notificationApi from '../../api/notificationApi'
import moment from 'moment'
import * as userApi from '../../api/userApi'
import { saveAccessToken, saveProjectInfo, saveUserInfo, saveBranchInfo } from '../../utils/userUtils'
import { SettingTwoTone, BellTwoTone, UserOutlined, SyncOutlined } from '@ant-design/icons'
import { getListUnitReport, getListUnit, getListCategorie } from '../../redux/ducks/settingDucks'
import { getListTransProvider } from '../../redux/ducks/transProviderDucks'
import { getListProductGroup } from '../../redux/ducks/productGroupDucks'
import { showMessage } from '../../utils/commonUtils'
import { useMenuChucNang } from '../../hooks/useMenuChucNang'
import { CHUC_NANG_PERMISSION_CODES } from '../../constants/permissionConstants'
import { getListMyDuAn } from '../../redux/ducks/userDucks'
import { PurchasesRequestChatByIdHost } from '../order/purchasesRequest/partials/PurchasesRequestCmtChatCells'
import { extractCmtFromNotificationContent } from '../order/purchasesRequest/purchasesRequestChatUtils'

export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  CMTYEUCAUMUA = 'CMTYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',

  COYEUCAUTIM = 'COYEUCAUTIM',
  CANXACNHANDONTIM = 'CANXACNHANDONTIM',
  COTHAYDOIDONTIM = 'COTHAYDOIDONTIM',
}

const { innerHeight: height } = window;
const styleActive = {
  background: "#07292d",
  borderRadius: 20,
  color: 'white',
  margin: 2

}
const styleInActive = {
  borderRadius: 20,
  background: "#d5e8ed",
  margin: 2
}
interface Props { }

const HeaderMenu: React.FC<Props> = () => {
  const dispatch: AppDispatch = useDispatch()
  const { hasChucNangByCode } = useMenuChucNang()
  const { pathname } = useLocation()
  const userInfo = getUserInfo()
  const projectInfo = getProjectInfo()
  const branchInfo = getBranchInfo()
  const notificationAllList = useSelector((state: RootState) => state.notification.notificationAllList || {})
  const myDuAnList = useSelector((state: RootState) => state.user.myDuAnList)
  
  // Call hook at top level
  const menuItems = useUserMenu()
  const isMounted = useRef(true)
  const [count, setCount] = useState(0)
  const [countNoty, setCountNoty] = useState({
    countXnbg: 0,
    countTdbg: 0,
    countYcm: 0,
    countCmtYcm: 0,
    countYct: 0,
    countYctt: 0,
    countXacNhanDonTim: 0,
    countThayDoiBaoGiaTimHang: 0,
    countCoYeuCauTim: 0,
  })
  const [notification, setNotification] = useState<any[]>([])
  const [visible, setVisible] = useState<boolean>(false)
  const [refType, setRefType] = useState<string>("ALL")
  const [duAns, setDuAns] = useState<any[]>([])
  const [chatYcmOpen, setChatYcmOpen] = useState<{
    id: string | number
    highlightCmt?: string
    highlightAt?: string
  } | null>(null)


  const filter = {
    from_date: moment().subtract(60, "days").format('YYYYMMDD'),
    to_date: moment().format('YYYYMMDD'),
  }

  // Cleanup khi component unmount
  useEffect(() => {
    isMounted.current = true
    return () => {
      isMounted.current = false
    }
  }, [])

  useEffect(() => {
    async function fetchExChangeRate() {
      try {
        const res = await getCurrentConfig()
        if (isMounted.current) {
          const rate = res.data.rateCnyVnd
          dispatch(setRateCnyToVnd(Number(rate.toFixed(2))))
        }
      } catch (error) {
        // Handle error silently
      }
    }
    fetchExChangeRate()
  }, [])

  useEffect(() => {
    getCommonData()
  }, [])

  const getCommonData = () => {
    dispatch(getListMyDuAn({}))
    // đơn vị khai báo
    dispatch(getListUnitReport())
    // đơn vị tính giá vốn
    dispatch(getListUnit())
    // đặc thù hàng
    dispatch(getListCategorie())
    // nhà cung cấp vận chuyển
    dispatch(getListTransProvider({}))
    // nhóm công bố
    dispatch(getListProductGroup({}))
  }

  useEffect(() => {
    let duAns: any[] = []

    if (Array.isArray(myDuAnList?.data) && myDuAnList?.data?.length > 0) {
      myDuAnList?.data?.map((item: any) => {
        if (Array.isArray(item.userNhomQuyens) && item.userNhomQuyens?.length > 0) {
          item.userNhomQuyens?.map((userNhomQuyen: any) => {
            duAns.push({ ...userNhomQuyen.chiNhanh, key: userNhomQuyen.chiNhanh.id, duAn: item })
          })
        } else {
          if (Array.isArray(item.chiNhanhs) && item.chiNhanhs?.length > 0) {
            item.chiNhanhs?.map((chiNhanh: any) => {
              duAns.push({ ...chiNhanh, key: chiNhanh.id, duAn: item })
            })
          }
        }
      })
      if (isMounted.current) {
        setDuAns(duAns)
      }
    }
  }, [myDuAnList])


  useEffect(() => {
    getNotification()
    
    const myInterval = window.setInterval(() => {
      getNotification()
    }, 3000 * 60)
    
    return () => clearInterval(myInterval)
  }, [])

  const getNotification = () => {
    if (!isMounted.current) return
    const stringified = queryString.stringify({ ...filter, page: 1, page_size: 1000 }, { skipEmptyString: true })
    dispatch(getListAllNotification(stringified))
  }

  useEffect(() => {
    if (!isMounted.current) return
    
    setCount(notificationAllList?.additionalData?.unReadCount || 0)
    let notify: any[] = []
    let notifyWatched: any[] = []
    let countXnbg = 0
    let countTdbg = 0
    let countYcm = 0
    let countCmtYcm = 0
    let countYct = 0
    let countYctt = 0
    let countXacNhanDonTim = 0, countThayDoiBaoGiaTimHang = 0, countCoYeuCauTim = 0
    if (Array.isArray(notificationAllList.data) && notificationAllList.data.length > 0) {
      notificationAllList.data.map(item => {
        countXnbg += (!item.watched && item.refType == notifyType.CANXACNHANBAOGIA) ? 1 : 0
        countTdbg += (!item.watched && item.refType == notifyType.COTHAYDOIBAOGIA) ? 1 : 0
        countYcm += (!item.watched && item.refType == notifyType.COYEUCAUMUA) ? 1 : 0
        countCmtYcm += (!item.watched && item.refType == notifyType.CMTYEUCAUMUA) ? 1 : 0
        countYct += (!item.watched && item.refType == notifyType.COYEUCAUTACH) ? 1 : 0
        countYctt += (!item.watched && item.refType == notifyType.COYEUCAUTHANHTOAN) ? 1 : 0

        countXacNhanDonTim += (!item.watched && item.refType == notifyType.CANXACNHANDONTIM) ? 1 : 0
        countThayDoiBaoGiaTimHang += (!item.watched && item.refType == notifyType.COTHAYDOIDONTIM) ? 1 : 0
        countCoYeuCauTim += (!item.watched && item.refType == notifyType.COYEUCAUTIM) ? 1 : 0

        if (item.refType == refType || refType == "ALL") {
          if (item.watched) {
            notifyWatched.push(item)
          } else {
            notify.push(item)
          }
        }
      })
    }
    
    if (isMounted.current) {
      setCountNoty({
        countXnbg: countXnbg,
        countTdbg: countTdbg,
        countYcm: countYcm,
        countCmtYcm: countCmtYcm,
        countYct: countYct,
        countYctt: countYctt,
        countXacNhanDonTim: countXacNhanDonTim,
        countThayDoiBaoGiaTimHang: countThayDoiBaoGiaTimHang,
        countCoYeuCauTim: countCoYeuCauTim,
      })
      setNotification([...notify, ...notifyWatched])
    }
  }, [notificationAllList, refType])

  const updateNofification = async (item: any) => {
    if (!item.watched) {
      await notificationApi.updateNotification(item.id)
      getNotification()
    }

    if (item.refType == notifyType.CANXACNHANBAOGIA || item.refType == notifyType.COTHAYDOIBAOGIA) {
      window.open(routerConstants.pricingConfirm.detail.replace(":id", item.refId))
    } else if (item.refType == notifyType.CMTYEUCAUMUA) {
      setChatYcmOpen({
        id: item.refId,
        highlightCmt: extractCmtFromNotificationContent(item.content),
        highlightAt: item.createdAt,
      })
    } else if (item.refType == notifyType.COYEUCAUMUA) {
      window.open(routerConstants.pricing.add);
    } else if (item.refType == notifyType.COYEUCAUTHANHTOAN) {
      window.open(routerConstants.requestPayment.list)
    } else {
      window.open(routerConstants.pricing.add)
    }
    setVisible(false)
  }

  const updateNofificationReadAll = async () => {
    await notificationApi.updateNotification("-1")
    getNotification()
    setVisible(false)
  }

  const changeBranch = async (item: any) => {
    const res = await userApi.changeBranch(item.duAnId, item.id)
    console.log("res", res)
    saveAccessToken(res.data.access_token)
    saveBranchInfo(JSON.stringify(res.data.chiNhanh))
    saveProjectInfo(JSON.stringify(res.data.duAn))
    const resUser = await userApi.getUserInfo()
    saveUserInfo(JSON.stringify(resUser.data))
    window.location.reload()
  }


  const handleSyncUser = async () => {
    try {
      await userApi.syncUser()
      showMessage('success', 'Đồng bộ user thành công')
    } catch (error) {
      showMessage('error', 'Đồng bộ user thất bại')
    }
  }

  const isHaveChucNangSyncUser = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_SYNC_USER)
  const isHaveChucNangNotiyConfirmPricing = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_CANXACNHANBAOGIA)
  const isHaveChucNangNotiyChangePricing = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COTHAYDOIBAOGIA)
  const isHaveChucNangNotiyPurchaseRequest = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUMUA)
  const isHaveChucNangNotiyRequestShare = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTACH)
  const isHaveChucNangNotiyPaymentRequest = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTHANHTOAN)
  const isHaveChucNangNotiyConfirmProductPricing = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_CANXACNHANDONTIM)
  const isHaveChucNangNotiyChangeProductPricing = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COTHAYDOIDONTIM)
  const isHaveChucNangNotiySearchRequest = hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_THONGBAO_COYEUCAUTIM)
  const isHaveChucNangNotiyCmtYcm =
    hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PRICING_ADD)
    || hasChucNangByCode(CHUC_NANG_PERMISSION_CODES.WEB_PURCHASES_REQUEST_ADD)

  return (
    <>

      <header style={{ width: '100%', padding: 0, height: '45px', paddingLeft: 20, paddingRight: 20 }}>
        <div className={'navbar-custom'} style={{ flex: 1, display: 'flex', flexDirection: 'row' }}>
          <div style={{
            backgroundColor: '#4e5455', width: '180px', justifyContent: 'center', alignContent: 'center',
            alignItems: 'center', borderRadius: 5, margin: "1px"
          }}>
            <Dropdown
              trigger={['click']}
              visible={visible}
              destroyPopupOnHide={true}
              overlay={
                <Menu style={{ top: 2, width: 450, maxHeight: height - 100, backgroundColor: 'white', border: "1px solid grey", position: 'absolute' }}>
                  <Menu.Item key={"notification-all"} style={{ borderBottomWidth: 2, backgroundColor: '#EEEEEE', borderBottom: "2px solid grey", marginTop: -2 }} >
                    <Button style={{ backgroundColor: "red", borderRadius: 20, color: 'white', marginRight: 10 }} size='small' onClick={() => setVisible(false)} type='text'>Đóng</Button>
                    <Button style={refType == "ALL" ? styleActive : styleInActive} size='small' onClick={() => setRefType("ALL")} type='text'>Tất cả - {count}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyConfirmPricing}
                      style={refType == notifyType.CANXACNHANBAOGIA ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.CANXACNHANBAOGIA)} type='text'
                    >Xác nhận báo giá - {countNoty.countXnbg}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyChangePricing}
                      style={refType == notifyType.COTHAYDOIBAOGIA ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COTHAYDOIBAOGIA)} type='text'
                    >Thay đổi báo giá - {countNoty.countTdbg}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyPurchaseRequest}
                      style={refType == notifyType.COYEUCAUMUA ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COYEUCAUMUA)} type='text'
                    >Yêu cầu mua - {countNoty.countYcm}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyCmtYcm}
                      style={refType == notifyType.CMTYEUCAUMUA ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.CMTYEUCAUMUA)} type='text'
                    >Cmt YCMH - {countNoty.countCmtYcm}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyRequestShare}
                      style={refType == notifyType.COYEUCAUTACH ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COYEUCAUTACH)} type='text'
                    >Yêu cầu tách - {countNoty.countYct}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyPaymentRequest}
                      style={refType == notifyType.COYEUCAUTHANHTOAN ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COYEUCAUTHANHTOAN)} type='text'
                    >Yêu cầu thanh toán - {countNoty.countYctt}</Button>

                    <Button
                      hidden={!isHaveChucNangNotiyConfirmProductPricing}
                      style={refType == notifyType.CANXACNHANDONTIM ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.CANXACNHANDONTIM)} type='text'
                    >Xác nhận BGTM - {countNoty.countXacNhanDonTim}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiyChangeProductPricing}
                      style={refType == notifyType.COTHAYDOIDONTIM ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COTHAYDOIDONTIM)} type='text'
                    >Thay đổi BGTM  - {countNoty.countThayDoiBaoGiaTimHang}</Button>
                    <Button
                      hidden={!isHaveChucNangNotiySearchRequest}
                      style={refType == notifyType.COYEUCAUTIM ? styleActive : styleInActive} size='small' onClick={() => setRefType(notifyType.COYEUCAUTIM)} type='text'
                    >Yêu cầu tìm - {countNoty.countCoYeuCauTim}</Button>


                    <Button size='small' onClick={() => window.open(routerConstants.notification.list)} type='link'
                    >Xem thông báo</Button>
                    <Button size='small' onClick={() => updateNofificationReadAll()} type='link'
                    >Đọc tất cả</Button>
                  </Menu.Item>
                  <Menu.Item key={"notification"} >
                    <div style={{ overflow: "scroll", maxHeight: height - 300, }}>
                      {
                        notification.map((item, index) => {
                          return (
                            <Row key={index} style={{ marginBottom: 10 }} onClick={() => updateNofification(item)} >
                              <div style={{
                                flexDirection: 'row',
                                display: 'flex',
                                fontWeight: item.watched ? "normal" : 'bold',
                                // color: item.watched ? 'black' : "blue",
                              }}>
                                <div style={{ flex: 1, color: item.watched ? 'black' : "blue", fontSize: 16 }}>{(index + 1) + " - " + item.title}</div>
                                <div style={{ fontSize: 12 }}>{moment(item.createdAt).format('DD/MM/YYYY | HH:mm')}</div>
                              </div>
                              <div dangerouslySetInnerHTML={{ __html: item.watched ? item.content.replace("#0000ff;", "black;") : item.content }}></div>
                            </Row>
                          )
                        })
                      }
                    </div>
                  </Menu.Item>
                </Menu>
              }
            >
              <div style={{
                color: 'white',
                flexDirection: 'row',
                display: 'flex',
                justifyContent: 'center', alignContent: 'center',
                alignItems: 'center',
              }}>
                <div style={{ justifyContent: 'center', alignContent: 'center', fontSize: "18px", marginRight: 5 }}>Thông báo</div>
                <Button type='text' onClick={() => setVisible(!visible)}
                  style={{
                    textAlign: 'center', fontSize: '16px', color: 'red',
                    height: '30px', backgroundColor: 'yellow',
                    paddingLeft: '5px', paddingRight: '5px', borderRadius: 20,
                    marginTop: "1px"
                  }}>
                  {count > 0 ? count + "  " : " "}<BellTwoTone />
                </Button>
              </div>
            </Dropdown>
          </div>
          <div style={{ flex: 1 }}>
            <Menu className='menu' mode="horizontal" key={pathname}>
              {menuItems.map((menuItem) => {
                if (menuItem.children.length > 0) {
                  const isSubMenuActive =
                    pathname.includes(menuItem.startPoint) ||
                    menuItem.children.some((sub) => pathname.includes(sub.startPoint));
                  return (
                    <Menu.SubMenu key={menuItem.key} title={menuItem.label} className={isSubMenuActive ? 'tree-menu-custom-active' : 'tree-menu-custom'} popupClassName='header-popup-menu-custom'>
                      {menuItem.children.map((subMenu, index2) => (
                        <Menu.Item key={menuItem.key + "-" + index2} className={pathname.includes(subMenu.startPoint) ? 'sub-menu-custom-active' : ''}>
                          <Link to={subMenu.path}>
                            <div className="theme-switcher-content">
                              {subMenu.icon && React.createElement(subMenu.icon, { style: { fontSize: '16px' } })}
                              <span>{subMenu.label}</span>
                            </div>
                          </Link>
                        </Menu.Item>
                      ))}
                    </Menu.SubMenu>
                  )
                } else {
                  return (
                    <Menu.Item key={menuItem.key} className={pathname.includes(menuItem.startPoint) ? 'menu-custom-active' : 'menu-custom'}>
                      <Link to={menuItem.path}>
                        <div className={`theme-switcher-button ${pathname.includes(menuItem.startPoint) ? 'active' : ''}`}>
                          <div className="theme-switcher-content">
                            {menuItem.icon && React.createElement(menuItem.icon, { style: { fontSize: '16px' } })}
                            <span>{menuItem.label}</span>
                          </div>
                        </div></Link>
                    </Menu.Item>
                  )
                }
              })}
            </Menu>
          </div>
        </div>

        {isHaveChucNangSyncUser && (
          <div style={{ backgroundColor: '#4e5455', margin: "2px", justifyContent: 'center', alignContent: 'center', borderRadius: 5 }}>
            <div style={{
              color: 'white',
              alignContent: 'center',
              paddingLeft: 10,
              paddingRight: 10
            }}
            >
              <div style={{ fontSize: '18px', color: 'white', flexDirection: 'row', display: 'flex' }}>
                <Button
                  icon={<SyncOutlined />}
                  onClick={handleSyncUser}
                  type="text" size="small"
                  style={{
                    color: 'white',
                    fontSize: '18px',
                  }}
                  className="hover:text-blue-500">
                  <span>User</span>
                </Button>
              </div>
            </div>
          </div>
        )}

        <div style={{ backgroundColor: '#4e5455', margin: "2px", justifyContent: 'center', alignContent: 'center', borderRadius: 5 }}>
          <Dropdown
            trigger={['click']}
            placement="bottomRight"
            destroyPopupOnHide={true}
            overlay={
              <Menu style={{ marginTop: 0, top: 5, border: "1px solid grey", backgroundColor: "#07292d", borderRadius: 5, }}>
                <Menu.Item key={1} style={{
                  backgroundColor: "#4e5455",
                  color: 'white', fontSize: 18, margin: 5, borderRadius: 5,
                  paddingTop: 7, paddingBottom: 7
                }} onClick={() => logOut()}>
                  <div>Đăng xuất</div>
                </Menu.Item>
                <Menu.Item key={2} style={{
                  backgroundColor: "#4e5455",
                  color: 'white', fontSize: 18, margin: 5, borderRadius: 5,
                  paddingTop: 7, paddingBottom: 7
                }} >
                  <Link to={routerConstants.user.changePWD}>Đổi mật khẩu</Link>
                </Menu.Item>
              </Menu>
            }
          >
            <div style={{
              color: 'white',
              alignContent: 'center',
              paddingLeft: 10,
              paddingRight: 10
            }}>
              <div style={{ fontSize: '18px', color: 'white', flexDirection: 'row', display: 'flex' }}>
                <div style={{ flex: 1 }}>
                  {userInfo?.username}
                </div>
                <div style={{ marginLeft: 5 }}>
                  <UserOutlined style={{ textAlign: 'right', color: '#FFFFFF' }} />
                </div>
              </div>
            </div>
          </Dropdown>
        </div>

        <div style={{ backgroundColor: '#4e5455', margin: "2px", justifyContent: 'center', alignContent: 'center', borderRadius: 5 }}>
          <Dropdown
            trigger={['click']}
            placement="bottomRight"
            destroyPopupOnHide={true}
            overlay={
              <Menu style={{ marginTop: 0, top: 5, border: "1px solid grey", backgroundColor: "#07292d", borderRadius: 5, }}>
                {
                  duAns.map((item, index) => {
                    return (<Menu.Item key={index} style={{
                      backgroundColor: item.ma == projectInfo?.ma ? "#4e5455" : "#07292d",
                      color: 'white', fontSize: 18, margin: 5, borderRadius: 5,
                      paddingTop: 7, paddingBottom: 7
                    }} onClick={() => changeBranch(item)} >
                      <div>{item?.duAn?.ma} - {item?.ma}</div>
                    </Menu.Item>
                    )
                  })
                }
              </Menu>
            }
          >
            <div style={{
              color: 'white',
              alignContent: 'center',
              paddingLeft: 10,
              paddingRight: 10
            }}>
              <div style={{ fontSize: '18px', color: 'white', flexDirection: 'row', display: 'flex' }}>
                <div style={{ flex: 1 }}>
                {projectInfo?.ten} - {branchInfo?.ten}
                </div>
                <div style={{ marginLeft: 5 }}>
                  <SettingTwoTone style={{ textAlign: 'right', color: '#FFFFFF' }} />
                </div>
              </div>
            </div>
          </Dropdown>
        </div>
      </header>

      <PurchasesRequestChatByIdHost
        yeuCauMuaId={chatYcmOpen?.id ?? null}
        highlightCmt={chatYcmOpen?.highlightCmt}
        highlightAt={chatYcmOpen?.highlightAt}
        onClose={() => setChatYcmOpen(null)}
      />
    </>
  )
}

export default HeaderMenu
